export default __webpack_public_path__ + "static/media/logo_horizental.07b8360b.jpg";